import axios from '@/api/axios';
import type {UserActiveCard} from '@/screens/User/Details/types';
import type {AfriexPaymentMethod, AfriexTransactionChannel} from '@/types';

export const paymentMethodService = {
  getUserActiveCards: async (userId: string): Promise<UserActiveCard[]> => {
    if (!userId) {
      return [];
    }
    const url = `/v2/admin/payment-methods/cards/${userId}`;
    const response = await axios.get<UserActiveCard[]>(url);
    const {data} = response;
    return data;
  },
  updateCardBankRegulatedStatus: async (
    userId: string,
    paymentMethodId: string,
    isRegulated: boolean,
  ): Promise<AfriexPaymentMethod> => {
    const body = {
      isRegulated,
      userId,
    };
    const response = await axios.patch<AfriexPaymentMethod>(
      `/v2/admin/payment-methods/cards/issuer/${paymentMethodId}`,
      body,
    );
    return response.data;
  },

  getUserPaymentMethods: async (
    userId: string,
    channel: AfriexTransactionChannel,
  ): Promise<{
    data: AfriexPaymentMethod[];
    limit: number;
    page: number;
    total: number;
  }> => {
    if (!userId) {
      return {data: [], limit: 0, page: 0, total: 0};
    }
    const url = `/v2/admin/payment-methods/user/${userId}?channel=${channel}`;
    const response = await axios.get<{
      data: AfriexPaymentMethod[];
      limit: number;
      page: number;
      total: number;
    }>(url);
    const {data: responseData} = response;
    return responseData;
  },

  getVirtualCardBalance: async (
    userId: string,
    virtualCardId: string,
  ): Promise<{
    balance: string;
  }> => {
    if (!userId || !virtualCardId) {
      return {balance: '0'};
    }
    const url = `/v2/admin/payment-methods/user/${userId}/virtual-cards/${virtualCardId}/balance`;
    const response = await axios.get<{balance: string}>(url);
    const {data: responseData} = response;
    return responseData;
  },
};
